import script from "./ChatIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatIcon.vue?vue&type=script&setup=true&lang=js"

import "./ChatIcon.vue?vue&type=style&index=0&id=f5a77a7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5a77a7e"]])

export default __exports__